<template>
  <div class="activity-details">
    <loading v-if="isLoading"></loading>
    <div v-else>
      <div v-if="!emptyShow">
        <div class="banner_container">
          <van-image width="100%" :src="detailData.coverImg" fit="contain"></van-image>
        </div>
        <div class="desc_container">
          <div class="desc_box">
            <div class="desc_left">
              <div class="desc_title">{{ detailData.name }}</div>
              <div class="desc_label_box" v-if="detailData.tag">
                <div
                  class="desc_label"
                  v-for="(item, index) in detailData.tag.split(',')"
                  :key="index"
                >
                  {{ item }}
                </div>
              </div>
            </div>
            <div class="desc_right">
              <div class="right_top">
                <div class="right_collect" @click="postCollect">
                  <img :src="collectObj.is_collect ? collectIconT : collectIconN" alt />
                  <div
                    :style="{
                      color: collectObj.is_collect ? '#FF504D' : '#262626',
                    }"
                  >
                    {{
                      Number(collectObj.count) >= 10000
                        ? (Number(collectObj.count) / 10000).toFixed(1) + "w"
                        : Number(collectObj.count) >= 1000
                        ? (Number(collectObj.count) / 1000).toFixed(1) + "k"
                        : Number(collectObj.count)
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="desc_bottom">
            <div class="bottom_item">
              <div class="bottom_icon">
                <img :src="activityName_icon" alt />
              </div>
              <div class="bottom_title bottom_location">
                <div class="title">活动主办</div>
                <div class="content" :style="{ color: 'black' }">
                  {{ detailData.sponsor }}
                </div>
              </div>
            </div>

            <div
              class="bottom_item"
              v-if="detailData.type == 2 && detailData.isEnroll == 1"
            >
              <div class="bottom_icon">
                <img :src="enollTime_icon" alt />
              </div>
              <div class="bottom_title bottom_location">
                <div class="title">报名时间</div>
                <div
                  v-if="detailData.isResident == 1"
                  class="content"
                  :style="{ color: 'black' }"
                >
                  常驻活动
                </div>
                <div
                  v-if="
                    detailData.isResident != 1 &&
                    detailData.enrollStartTime &&
                    detailData.enrollEndTime
                  "
                  class="content"
                  :style="{ color: 'black' }"
                >
                  {{ detailData.enrollStartTime | dateFrm }} -
                  {{ detailData.enrollEndTime | dateFrm }}
                </div>
              </div>
            </div>

            <div class="bottom_item">
              <div class="bottom_icon">
                <img :src="enollTime_icon" alt />
              </div>
              <div class="bottom_title bottom_location">
                <div class="title">活动时间</div>
                <div
                  class="content"
                  v-if="detailData.isResident == 1"
                  :style="{ color: 'black' }"
                >
                  常驻活动
                </div>
                <div
                  class="content"
                  v-if="
                    detailData.isResident != 1 &&
                    detailData.activityStartTime &&
                    detailData.activityEndTime
                  "
                  :style="{ color: 'black' }"
                >
                  {{ detailData.activityStartTime | dateFrm("MM.DD HH:mm") }} -
                  {{ detailData.activityEndTime | dateFrm("MM.DD HH:mm") }}
                </div>
              </div>
            </div>
            <div class="bottom_item" v-if="detailData.scenicName">
              <div class="bottom_icon">
                <img :src="sen_icon" alt />
              </div>
              <div class="bottom_title bottom_location">
                <div class="title">开展景区</div>
                <div class="content" :style="{ color: 'black' }">
                  {{ detailData.scenicName }}
                </div>
              </div>
            </div>
            <div
              class="bottom_item"
              v-if="
                detailData.enrollModel != null &&
                detailData.enrollModel == 0 &&
                detailData.enrollLimit
              "
            >
              <div class="bottom_icon">
                <img :src="limit_icon" alt />
              </div>
              <div class="bottom_title bottom_location">
                <div class="title">上限人数</div>
                <div class="content" :style="{ color: 'black' }">
                  {{ detailData.enrollLimit }}
                </div>
              </div>
            </div>
            <div class="bottom_item">
              <div class="bottom_icon">
                <img :src="activityLocation_icon" alt />
              </div>
              <div class="bottom_title bottom_location" @click="toMap(detailData)">
                <div class="title">活动地点</div>
                <div class="content" :style="{ color: 'black' }">
                  {{ detailData.address }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <van-tabs
          v-model="tabIndex"
          sticky
          @click="tabsClick"
          v-if="messageList.length > 0 && momentList.length > 0"
        >
          <van-tab class="detail_tab" title="活动详情">
            <div class="intro_container">
              <div class="intro_title">活动介绍</div>
              <div
                class="intro_innerText"
                :style="{ marginBottom: '30px' }"
                v-html="detailData.brief"
              ></div>
              <div class="intro_title">活动内容</div>
              <div class="intro_innerText" v-html="detailData.content"></div>
            </div>
          </van-tab>
          <van-tab class="info_tab" title="即时资讯" v-if="messageList.length > 0">
            <div
              class="realTime_container"
              v-for="(item, index) in messageList"
              :key="index"
            >
              <div class="realTime_title">{{ item.title }}</div>
              <div class="realTime_text" :ref="'realTime_text' + index">
                <div
                  class="text"
                  :class="{ text_line: foldArr[index] }"
                  v-html="item.content"
                ></div>
              </div>
              <div
                v-if="isShowFold[index]"
                class="fold_text"
                @click="foldState"
                :data-index="index"
              >
                {{ foldArr[index] ? "展开" : "收起" }}
              </div>
              <div class="realTime_img" :style="{ width: '100%', minHeight: '50px' }">
                <van-image
                  :src="item.imagePath"
                  width="100%"
                  height="auto"
                  :style="{ minHeight: '100px' }"
                ></van-image>
              </div>
            </div>
          </van-tab>
          <van-tab class="video_tab" title="精彩瞬间" v-if="momentList.length > 0">
            <div class="pic_container">
              <div
                class="pic_item"
                v-for="(item, index) in momentList"
                :key="index"
                @click.stop="toAllList(item.imagePath)"
              >
                <van-image
                  v-if="item.type == 0"
                  :radius="3"
                  :src="item.imagePath"
                ></van-image>
                <video
                  v-if="item.type == 1"
                  :src="item.imagePath"
                  poster="../../assets/img/canvas_default.png"
                ></video>
                <img
                  v-if="item.type == 1"
                  class="video_icon"
                  src="../../assets/img/playVideo_icon.png"
                  alt=""
                />
              </div>
            </div>
          </van-tab>
        </van-tabs>
        <div class="intro_container" v-else>
          <div class="intro_title">活动介绍</div>
          <div
            class="intro_innerText"
            :style="{ marginBottom: '30px' }"
            v-html="detailData.brief"
          ></div>
          <div class="intro_title">活动内容</div>
          <div class="intro_innerText" v-html="detailData.content"></div>
        </div>
        <div class="btn_box" v-if="!detailData.buyTicketAddress">
          <div
            class="btn_primary"
            v-if="detailData.userIsEnroll == 2"
            @click="postCollect"
          >
            立即报名
          </div>
          <div class="btn_after" v-if="detailData.userIsEnroll == 1">已报名</div>
          <div class="btn_stop" v-if="detailData.userIsEnroll == 3">报名已截止</div>
        </div>
        <div class="btn_box" v-else>
          <div
            class="btn_primary"
            v-if="detailData.activity_status !== '已结束'"
            @click="postCollect"
          >
            购买门票
          </div>
        </div>
      </div>
      <empty
        v-else
        ref="emptyView"
        :toastTitle="toastTitle"
        :emptyShow="emptyShow"
        :style="{ top: emptyTop }"
      ></empty>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Loading from "@/components/loading";
import qs from "qs";
import Vue from "vue";
import Vant, { Lazyload } from "vant";
Vue.use(Lazyload);
Vue.use(Vant);
import empty from "@/components/empty.vue";
export default {
  data() {
    return {
      isLoading: true,
      // 图片数组
      CommentNum: 0, // 评论条数
      commentList: [],
      collectObj: {
        count: 0,
      },
      detailData: {},
      id: this.$route.query.id,

      collectIconN: require("../../assets/iconImage/ic_collection_nor@3x.png"),
      collectIconT: require("../../assets/iconImage/ic_collection@3x.png"),

      activityName_icon: require("../../assets/iconImage/activityName_icon.png"),
      enollTime_icon: require("../../assets/iconImage/enollTime_icon.png"),
      sen_icon: require("../../assets/iconImage/sen_icon.png"),
      limit_icon: require("../../assets/iconImage/limit_icon.png"),
      activityLocation_icon: require("../../assets/iconImage/activityLocation_icon.png"),

      session_id: this.$route.query.session_id,
      toastTitle: "糟糕,数据找不到了",
      emptyShow: false,
      emptyTop: "46px",
      openTitle: "打开天府绿道APP<br/>活动尽收眼底",
      shareId: this.$route.query.id,
      shareType: "",
      messageList: [], // 活动资讯
      momentList: [], // 视频/图片
      tabIndex: 0, // 0 活动详情 1 即时资讯 2 精彩瞬间
      foldArr: [], // 默认不收起，收起状态会影响行数计算(已在循环内做二次处理)
      isShowFold: [], // 是否显示 展开按钮
    };
  },
  components: {
    Loading,
    empty,
  },
  created() {
    document.title = "活动详情";
    this.getDetail();
  },
  mounted() {},
  methods: {
    /**
     * 购买门票
     */
    toBuyTicket(url) {
      // window.location.href = url;
    },
    /**
     * 循环判断即时资讯行数 设置展开或者收起状态
     */
    loopJudjeLine() {
      console.log("判断行数");
      console.log(this.$refs, "this.refs");
      for (let i in this.foldArr) {
        console.log(this.$refs[`realTime_text${i}`], "sdasda");
        let rowNum = Math.round(
          $(this.$refs[`realTime_text${i}`]).height() /
            parseFloat($(this.$refs[`realTime_text${i}`]).css("line-height"))
        );
        // rowNum = rowNum - 1; // 减去展开按钮占的一行
        console.log(rowNum, "rowNum");
        this.isShowFold[i] = rowNum > 3;
        this.foldArr[i] = true; // 默认为可展开状态
        // console.log(this.isShowFold[i], 'this.isShowFold[i]')
      }
      this.$forceUpdate();
    },

    /** tabs切换 */
    tabsClick(name, title) {
      console.log(name, "namename");
      console.log(title, "titletitle");
      if (name == 1) {
        // 即时资讯
        this.$nextTick(() => {
          this.loopJudjeLine();
        });
      } else {
        for (let i in this.foldArr) {
          // 切换重置状态，用于避免计算行数错误
          this.foldArr[i] = false;
        }
      }
    },

    computedLine(e) {
      console.log(e, "computedLine");
    },

    /**
     * 展开/收起
     */
    foldState(event) {
      let index = event.currentTarget.dataset.index;
      this.foldArr[index] = !this.foldArr[index];
      this.$forceUpdate();
    },
    getDetail() {
      this.$http
        .get(`/appserver/v1/activity/preview?id=${this.$route.query.id}`)
        .then((data) => {
          if (data.data.ret == 0) {
            this.emptyShow = false;
            let resData = data.data.data;
            this.isLoading = false;
            this.detailData = resData;
            if (resData.messag != null) {
              this.messageList = resData.messag;
            }
            if (resData.moment != null) {
              this.momentList = resData.moment;
            }
          } else {
            console.log("报错了");
            this.isLoading = false;
            this.toastTitle = data.data.msg;
            this.emptyShow = true;
          }
        })
        .catch((e) => {
          // this.isLoading = false;
          // this.toastTitle = "网络出错,请稍后再试!";
          // this.emptyShow = true;
        });
      this.getCollectNum();
    },
    getCollectNum() {
      this.$http
        .get(`/appserver/v1/collect/is/collect?srcType=activity&srcId=${this.id}`)
        .then((res) => {
          if (res.data.ret == 0) {
            let resData = res.data.data;
            this.collectObj = resData;
          }
        })
        .catch((e) => {});
    },

    openApp() {
      //打开APP,跳转到APP
      //eslint-disable-next-line
      console.log("openApp()");
    },
    postCollect() {},
  },
};
</script>

<style lang="scss">
.site p img {
  width: 100%;
}
</style>
<style lang="scss" scoped>
.activity-details {
  /deep/.van-tab__text {
    color: #787878;
    font-size: 16px;
  }

  /deep/.van-tab--active {
    .van-tab__text {
      font-weight: bold;
      color: #262626;
    }
  }

  /deep/.van-tabs__line {
    width: 20px;
    height: 4px;
    background: #2ed07e;
    border-radius: 2px;
  }

  /deep/.van-tabs__nav {
    // padding: 0 20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 10px;
  }

  /deep/.van-tab {
    flex: none;
    padding-left: 0px;
    padding-right: 0px;
    margin-right: 30px;
  }

  .info_tab {
    min-height: calc(100vh - 74px);
  }

  .video_tab {
    min-height: calc(100vh - 44px);
  }

  .detail_tab {
    min-height: calc(100vh - 44px);
  }

  .intro_container {
    padding: 30px 20px;
    color: #262626;

    .intro_title {
      font-size: 20px;
      font-weight: 700;
    }

    .intro_innerText {
      font-size: 14px;
      margin-top: 10px;
      min-height: 20px;

      /deep/img {
        width: 100%;
      }

      //   width: 200px;
    }

    // padding-bottom: 70px;
  }

  .realTime_container {
    padding: 0px 20px;
    color: #262626;

    .realTime_title {
      font-size: 18px;
      font-weight: bold;
      margin: 20px 0px 15px 0px;
    }

    .realTime_text {
      font-size: 14px;
      color: #787878;
      min-height: 20px;
    }

    .fold_text {
      font-size: 13px;
      color: #2eba73;
    }

    .text_line {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box; //将对象作为弹性伸缩盒子模型显示
      -webkit-line-clamp: 3; //控制显示几行文字
      -webkit-box-orient: vertical; //设置伸缩盒对象的子元素排列方式
    }

    .realTime_img {
      margin: 20px 0px;
    }
  }

  .pic_container {
    width: 100%;
    padding: 5px 20px;
    box-sizing: border-box;

    & > div:nth-child(even) {
      // 偶数
      padding-left: 7.5px;
    }

    & > div:nth-child(odd) {
      // 奇数
      padding-right: 7.5px;
    }

    & > .pic_item {
      display: inline-block;
      width: 50%;
      box-sizing: border-box;
      padding: 7.5px 0px;
      height: 175px; // 160 + 15
      position: relative;

      // overflow: hidden;
      .van-image {
        width: 100%;
        height: 100%;
        border-radius: 3px;
      }

      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 3px;
      }

      .video_icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 60px;
        height: 60px;
      }
    }
  }

  .banner_container {
    position: relative;
    width: 100%;
    // min-height: 177px;
    height: 250px;
    // background: gray;
    .video_ele {
      width: 100%;
      height: 177px;
      object-fit: fill;
    }

    .indicator_box {
      position: absolute;
      bottom: 20px;
      right: 20px;
      color: white;
    }
  }

  .desc_container {
    padding: 10px 20px 30px 20px;
    border-bottom: 5px solid rgba(0, 0, 0, 0.05);
    border-radius: 12px 12px 0px 0px;
    transform: translateY(-10px);
    background: white;

    .live_box {
      margin: 60px 0px 30px 0px;
      height: 130px;
      background: linear-gradient(
          270deg,
          rgba(176, 3, 71, 0) 0%,
          rgba(176, 3, 71, 1) 100%
        ),
        url("../../assets/iconImage/ic_collection@3x.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      border-radius: 0px 3px 3px 0px;
      position: relative;

      .top_info {
        position: absolute;
        top: 0;
        left: 0;
        height: 24px;
        padding: 0 10px;
        background: #8f70ff;
        color: white;
        min-height: 24px;
        border-radius: 3px 0px 14px 0px;
        font-size: 12px;
      }

      .top_bottom {
        position: absolute;
        bottom: 20px;
        left: 0;
        font-size: 15px;
        color: white;
        padding-left: 20px;

        .bottom_top {
          font-weight: bold;
        }

        .bottom_desc {
          font-size: 12px;
        }
      }
    }

    .desc_box {
      display: flex;
      justify-content: space-between;

      .desc_left {
        padding-top: 20px;
      }

      .desc_right {
        .right_top {
          display: flex;

          .right_collect {
            display: flex;
            align-items: flex-start;

            div {
              font-size: 12px;
              color: #262626;
              margin-left: 2px;
            }
          }

          img {
            width: 24px;
            height: 24px;
            vertical-align: top;
            margin-left: 20px;
          }
        }
      }
    }

    .desc_title {
      font-size: 24px;
      color: #262626;
      font-weight: 700;
    }

    .desc_label_box {
      margin-top: 10px;

      .desc_label {
        padding: 2px 5px;
        background: rgba(97, 69, 247, 0.15);
        color: #6145f7;
        display: inline-block;
        margin-right: 5px;
      }
    }

    .desc_bottom {
      display: flex;
      flex-direction: column;
      // align-items: center;
      justify-content: center;
      margin-top: 30px;
      background: rgba(46, 186, 115, 0.08);
      padding-top: 20px;
      padding-left: 22px;
      padding-right: 10px;
      border-radius: 1px;

      .bottom_item {
        display: flex;
        font-size: 14px;
        margin-bottom: 20px;

        // align-items: center;
        div {
          display: inline-block;
        }

        .bottom_icon {
          // display: flex;
          // align-items: center;
          transform: translateY(3px);

          img {
            width: 16px;
            height: 16px;
          }
        }

        .bottom_title {
          color: #787878;
          margin-left: 13px;
          margin-right: 15px;
          display: flex;
          // align-items: center;
        }

        .bottom_location {
          width: 100%;
          .title {
            width: 20vw;
          }

          .content {
            width: 70%;
          }
        }

        .bottom_content {
          color: #262626;
        }
      }
    }
  }

  .intro_container {
    padding: 30px 20px;
    color: #262626;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);

    .intro_title {
      font-size: 20px;
      font-weight: 700;
    }

    .intro_innerText {
      margin-top: 10px;
      min-height: 20px;

      /deep/img {
        width: 100%;
      }

      //   width: 200px;
    }
  }

  .btn_box {
    padding: 18px 20px;
    display: flex;
    justify-content: center;

    .btn_primary {
      width: 95%;
      height: 42px;
      min-height: 42px;
      font-size: 15px;
      color: white;
      text-align: center;
      background: #2eba73;
      line-height: 42px;
    }

    .btn_after {
      width: 95%;
      height: 42px;
      min-height: 42px;
      font-size: 15px;
      color: #2eba73;
      text-align: center;
      background: #f2f2f2;
    }

    .btn_stop {
      width: 95%;
      height: 42px;
      min-height: 42px;
      font-size: 15px;
      color: #bfbfbf;
      text-align: center;
      background: #f2f2f2;
    }
  }
}
</style>
